<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_33309_31449)">
      <path
        d="M17.8929 17.8929C15.5357 20.325 15.3643 23.3571 15.1607 30C21.3536 30 25.6286 29.9786 27.8357 27.8357C29.9786 25.6286 30 21.15 30 15.1607C23.3571 15.375 20.325 15.5357 17.8929 17.8929ZM0 15.1607C0 21.15 0.0214285 25.6286 2.16429 27.8357C4.37143 29.9786 8.64643 30 14.8393 30C14.625 23.3571 14.4643 20.325 12.1071 17.8929C9.675 15.5357 6.64286 15.3643 0 15.1607ZM14.8393 0C8.65714 0 4.37143 0.0214285 2.16429 2.16429C0.0214285 4.37143 0 8.85 0 14.8393C6.64286 14.625 9.675 14.4643 12.1071 12.1071C14.4643 9.675 14.6357 6.64286 14.8393 0ZM17.8929 12.1071C15.5357 9.675 15.3643 6.64286 15.1607 0C21.3536 0 25.6286 0.0214285 27.8357 2.16429C29.9786 4.37143 30 8.85 30 14.8393C23.3571 14.625 20.325 14.4643 17.8929 12.1071Z"
        fill="#3176FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_33309_31449">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts" setup></script>

<style></style>
